import { createFileRoute } from '@tanstack/react-router';

import DayToDayForm from 'src/components/DayToDayForm';
import PageHeader from 'src/components/PageHeader';
import { InnerMaxWidthContainer } from 'src/layouts/InnerMaxWidthContainer';

export const Route = createFileRoute('/(app)/care/day-to-day/meals')({
    component: AdlsEditMealsComponent,
});

function AdlsEditMealsComponent() {
    return (
        <InnerMaxWidthContainer>
            <PageHeader />
            <DayToDayForm
                dayToDayName="MEAL_PREFERENCES"
                title="Meal Preferences"
                description="Share any food likes, dislikes, or restrictions so meals can be tailored to their needs."
                placeholder="e.g., prefers vegetarian meals, avoids dairy, loves soup"
                nextRoute="/care/day-to-day/routines"
            />
        </InnerMaxWidthContainer>
    );
}
